import { render, staticRenderFns } from "./DownloadMaterial.vue?vue&type=template&id=e00a7c66&scoped=true&"
import script from "./DownloadMaterial.vue?vue&type=script&lang=js&"
export * from "./DownloadMaterial.vue?vue&type=script&lang=js&"
import style0 from "./DownloadMaterial.vue?vue&type=style&index=0&id=e00a7c66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00a7c66",
  null
  
)

export default component.exports